class TimelineConnector extends HTMLElement {
  constructor() {
    super();
    this.line = this.querySelector('.timeline__connector-line');
    this.icons = Array.from(this.querySelectorAll('.timeline__marker-icon'));
    this.resizeTimeout = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.line || this.icons.length < 2) return;
    this.updateLine();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.resizeTimeout);
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.updateLine(), 150);
  }

  updateLine() {
    const containerRect = this.getBoundingClientRect();
    const rows = Array.from(this.querySelectorAll('.timeline__row'));
    const lastCard = rows.length ? rows[rows.length - 1].querySelector('.timeline__card') : null;

    const firstRect = this.icons[0].getBoundingClientRect();
    const lastIconRect = this.icons[this.icons.length - 1].getBoundingClientRect();

    const firstCenterY = firstRect.top + firstRect.height / 2 - containerRect.top;
    const lastIconCenterY = lastIconRect.top + lastIconRect.height / 2 - containerRect.top;
    const centerX = firstRect.left + firstRect.width / 2 - containerRect.left;

    let endY = lastIconCenterY;
    if (lastCard) {
      endY = lastIconCenterY + lastCard.getBoundingClientRect().height / 2;
    }

    this.line.style.top = `${firstCenterY}px`;
    this.line.style.height = `${Math.max(endY - firstCenterY, 0)}px`;
    this.line.style.left = `${centerX}px`;
  }
}

customElements.define('timeline-connector', TimelineConnector);
